<template>
    <v-card>
        <v-card-title class="justify-center" style="font-size: 1.5em;">
            Editar Informações do Frentista
        </v-card-title>
        <v-card-text>
            <v-layout
                wrap
                justify-space-around
            >
                <v-flex xs5>
                    <v-text-field
                        label="Nome"
                        v-model="nome"
                        :rules="[
                            v => !!v || 'Campo Obrigatório'
                        ]"
                    />
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        label="Sobrenome"
                        v-model="sobrenome"
                    />
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        label="CPF"
                        v-model="cpf"
                        mask="###.###.###-##"
                        :rules="[
                            v => !!v || 'Campo Obrigatório'
                        ]"
                    />
                    <h5
                        class="error--text text-xs-center"
                        v-show="cpfExiste"
                    >
                        CPF já existe
                    </h5>
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        label="Matrícula"
                        v-model="matricula"
                        mask="####"
                        :rules="[
                            v => !!v || 'Campo Obrigatório'
                        ]"
                    />
                    <h5
                        class="error--text text-xs-center"
                        v-show="matriculaExiste"
                    >
                        Matrícula já existe
                    </h5>
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        label="Telefone"
                        v-model="telefone"
                        mask="(##) # ####-####"
                    />
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        label="E-mail"
                        v-model="email"
                        :readonly="!frentista.pessoa"
                    />
                </v-flex>
                <v-flex xs7 class="mb-3">
                  <h4 class="text-xs-center">Digite um novo PIN para o frentista</h4>
                    <v-text-field
                        style="text-align:center"
                        label="Novo PIN"
                        v-model="pin"
                        outline
                        :type="show ? 'text' : 'password'"
                        :append-icon="show ? 'visibility' : 'visibility_off'"
                        @click:append="show = !show"
                        required
                        placeholder="****"
                        counter="4"
                        single-line
                        hide-details
                        class="centered-input display-1 font-weight-black"
                        browser-autocomplete="off"
                        mask="####"
                    />
                </v-flex>
                <v-flex xs12>
                  <h2 class="text-xs-center mb-2">
                    Funções
                  </h2>
                </v-flex>
                <v-flex xs5>
                  <v-btn
                    :disabled="!frentista.pessoa"
                    block
                    round
                    :loading="loading"
                    color="success"
                    @click="editarUsuario(
                      {
                        email_verified: true
                      }
                    )"
                  >
                    Verificar e-mail
                  </v-btn>
                </v-flex>
                <v-flex xs5>
                  <v-btn
                  :disabled="!frentista.pessoa"
                    :loading="loading"
                    block
                    round
                    color="secondary"
                    @click="editarUsuario(
                      {
                        redefinir_senha: true
                      }
                    )"
                  >
                    Redefinir Senha
                  </v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn
                color="primary"
                block
                :disabled="matriculaExiste || cpfExiste"
                @click="editarFrentista"
                class="mb-2"
            >
                <v-icon class="mr-1">edit</v-icon>
                Editar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['frentista', 'posto'],
  data: () => ({
    nome: '',
    sobrenome: '',
    telefone: '',
    matricula: '',
    cpf: '',
    matriculaExiste: false,
    cpfExiste: false,
    email: undefined,
    pin: undefined,
    show: false
  }),
  beforeMount () {
    if (this.frentista) {
      this.nome = this.frentista.nome
      this.sobrenome = this.frentista.sobrenome
      this.telefone = this.frentista.telefone
      this.matricula = this.frentista.matricula
      this.cpf = this.frentista.cpf
      this.email = this.frentista.pessoa ? this.frentista.pessoa.email : undefined
    }
  },
  methods: {
    editarFrentista () {
      if (this.frentista.pessoa && this.email !== undefined && this.email !== this.frentista.pessoa.email) {
        this.editarUsuario({
          email: this.email
        })
      }
      this.$store.dispatch('editarFrentista', {
        id_frentista: this.frentista.id_frentista,
        nome: this.nome,
        sobrenome: this.sobrenome ? this.sobrenome : null,
        telefone: this.telefone ? this.telefone : null,
        matricula: this.matricula,
        cpf: this.cpf,
        pin: this.pin ? this.pin : null
      }).then(() => {
        this.$emit('carregar')
        this.$emit('fechar')
      })
    },
    async verificarDados (data) {
      data.posto = this.posto.cnpj
      let existe = false
      await this.$store.dispatch('frentistas', data).then(json => {
        if (json.length > 0) {
          for (let f in json) {
            if (json[f].id_frentista !== this.frentista.id_frentista) {
              existe = true
            }
          }
        }
      })
      return existe
    },
    editarUsuario (data) {
      data.id_pessoa = this.frentista.pessoa.id_pessoa
      this.$store.dispatch('updatePessoa', data).then(() => {
        this.$emit('carregar')
      })
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    matricula (val) {
      if (val) {
        this.verificarDados({ matricula: val }).then(value => {
          this.matriculaExiste = value
        })
      }
    },
    cpf (val) {
      if (val) {
        this.verificarDados({ cpf: val }).then(value => {
          this.cpfExiste = value
        })
      }
    }
  }
}
</script>
